<div class="page-background">
  <div class="privacy-card">
    <ng-container *transloco="let t; read: 'privacyPolicy'">
      <header class="form-header">
        <img src="assets/images/logos/beetrics-logo.svg" alt="Beetrics Logo" />
      </header>
      <div class="privacy-content">
        <h1>{{ t('title') }}</h1>
        <p>{{ t('intro') }}</p>

        <dl>
          <dt><strong>{{ t('responsible.label') }}</strong></dt>
          <dd>{{ t('responsible.value') }}</dd>
          <dt><strong>{{ t('cif.label') }}</strong></dt>
          <dd>{{ t('cif.value') }}</dd>
          <dt><strong>{{ t('address.label') }}</strong></dt>
          <dd>{{ t('address.value') }}</dd>
          <dt><strong>{{ t('phone.label') }}</strong></dt>
          <dd>{{ t('phone.value') }}</dd>
          <dt><strong>{{ t('mail.label') }}</strong></dt>
          <dd><a [href]="'mailto:' + t('mail.value')">{{ t('mail.value') }}</a></dd>
        </dl>

        <h2>{{ t('purpose.title') }}</h2>
        <p>{{ t('purpose.p1') }}</p>
        <ul>
          <li>{{ t('purpose.l1') }}</li>
          <li>{{ t('purpose.l2') }}</li>
          <li>{{ t('purpose.l3') }}</li>
        </ul>
        <p>{{ t('purpose.p2') }}</p>
        <p>{{ t('purpose.p3') }}</p>
        <p>{{ t('purpose.p4') }}</p>

        <h2>{{ t('legitimation.title') }}</h2>
        <p>{{ t('legitimation.p1') }}</p>
        <ul>
          <li>{{ t('legitimation.l1') }}</li>
          <li>{{ t('legitimation.l2') }}</li>
        </ul>

        <h2>{{ t('recipients.title') }}</h2>
        <p>{{ t('recipients.p1') }}</p>

        <h2>{{ t('conservation.title') }}</h2>
        <p>{{ t('conservation.p1') }}</p>
        <p>{{ t('conservation.p2') }}</p>
        <p>{{ t('conservation.p3') }}</p>

        <h2>{{ t('rights.title') }}</h2>
        <p>{{ t('rights.p1') }}</p>
        <p>{{ t('rights.p2') }}</p>
        <p>{{ t('rights.p3') }}</p>
        <p>{{ t('rights.p4') }}</p>
        <p>{{ t('rights.p5') }}</p>
        <p
          [innerHTML]="t('rights.p6', { email: t('mail.value'), address: t('address.value') })"
        ></p>

        <h2>{{ t('accuracy.title') }}</h2>
        <p>{{ t('accuracy.p1') }}</p>
        <p>{{ t('accuracy.p2') }}</p>
        <p>{{ t('accuracy.p3') }}</p>
        <p>{{ t('accuracy.p4') }}</p>
        <p [innerHTML]="t('accuracy.p5', { url: 'https://www.aepd.es', text: 'www.aepd.es' })"></p>
      </div>
    </ng-container>
  </div>
</div>
